// @flow

import React from 'react';
import {useState} from 'react';
import { log } from '../../utils/jsUtils';
import { useSelector, useDispatch } from 'react-redux';

import AppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

import AssignIcon from '@mui/icons-material/Share';
import Zoom from '@mui/material/Zoom';

import HeaderTopBar from '../HeaderTopBar';

import memberHeaderStyles from '../Feed/Styles/MemberHeader.Style';
import { setAnalyticsTimeRange } from '../../reduxStore/modules/analytics/actions';
import { selectIsDemoMode } from '../../reduxStore/modules/common/selectors';

type Props = {
  mobileOpen: bool,
  usehandleDrawerToggle: Function,
};

const AnalyticsHeader = (props: Props) => {
  log('[AnalyticsHeader] props: ', props);
  const {
    usehandleDrawerToggle
  } = props;

  const theme = useTheme();
  const dispatch = useDispatch();
  const [openDateRangeFilterOptions, setOpenDateRangeFilterOptions] = useState(null);

  // Get data from Redux
  const isDemoMode = useSelector(selectIsDemoMode);
  
  const handleNumberOfDaysClick = (days: number) => {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(endDate.getDate() - days);
    
    dispatch(setAnalyticsTimeRange({
      startDate,
      endDate
    }));
    
    setOpenDateRangeFilterOptions(null);
  };

  return (
    <AppBar
      sx={memberHeaderStyles.appBar(theme)}
      position="fixed"
    >
      <Toolbar
        sx={memberHeaderStyles.toolbar(theme)}
        disableGutters
      >
        <Grid
          container
          direction='column'
        >
          <HeaderTopBar
            usehandleDrawerToggle={usehandleDrawerToggle}
          >
            <Typography
              sx={memberHeaderStyles.pageTitle(theme)}
              variant='h2'
            >{'Analytics'}</Typography>
          </HeaderTopBar>
          <Grid
            sx={{
              ...memberHeaderStyles.rowSub(theme),
              ...memberHeaderStyles.bottomBar(theme)
            }}
            item
          >
            <Grid
              sx={memberHeaderStyles.bottomBarContainer(theme)}
              container
            >
              {
                isDemoMode
                ? <Box
                    sx={{
                      ...memberHeaderStyles.toggleContainer(theme),
                      ...memberHeaderStyles.dividerRight(theme)
                    }}
                  >
                  <Tooltip
                    aria-label={'Create a report'}
                    title={'Create a report'}
                  >
                    <Button
                      sx={memberHeaderStyles.navButton(theme)}
                    >
                      <i className={'icon-add'} />
                      <div>{'Report'}</div>
                    </Button>
                  </Tooltip>
                </Box>
                : null
              }
              {
                isDemoMode
                ? <Box
                    sx={memberHeaderStyles.toggleContainer(theme)}
                  >
                  <Tooltip
                    aria-label={'Assign'}
                    title={'Assign'}
                  >
                    <Button
                      sx={memberHeaderStyles.navButton(theme)}
                    >
                      <i className={'icon-assign'} />
                      <div>{'Assign'}</div>
                    </Button>
                  </Tooltip>
                </Box>
                : null
              }

              {
                isDemoMode
                ? <Box
                    sx={memberHeaderStyles.toggleContainer(theme)}
                  >
                    <Tooltip
                      aria-label={'Share'}
                      title={'Share'}
                    >
                      <Button
                        sx={memberHeaderStyles.navButton(theme)}
                      >
                        <AssignIcon fontSize="small" />
                        <div>{'Share'}</div>
                      </Button>
                    </Tooltip>
                  </Box>
                : null
              }

              <Box sx={memberHeaderStyles.grow(theme)} />
                <Box
                  sx={memberHeaderStyles.toggleContainer(theme)}
                >
                  <Tooltip title = 'Filter by date range'>
                    <Button
                      aria-controls="menu-list-grow"
                      aria-haspopup="true"
                      sx={memberHeaderStyles.navButton(theme)}
                      onClick={(e) => setOpenDateRangeFilterOptions(e.currentTarget)}
                    >
                      <i className='icon-calendar' />
                      <div>{'Filter'}</div>
                    </Button>
                  </Tooltip>
                  <Menu
                    anchorEl={openDateRangeFilterOptions}
                    slotProps={{
                      paper: {
                        sx: memberHeaderStyles.menuRoot(theme)
                      }
                    }}
                    disableAutoFocusItem
                    id="header-date-range-filter"
                    key='2'
                    // eslint-disable-next-line react/jsx-sort-props
                    MenuListProps={{
                      sx: memberHeaderStyles.subMenuListRoot(theme)
                    }}
                    onClose={() => setOpenDateRangeFilterOptions(null)}
                    open={Boolean(openDateRangeFilterOptions)}
                  >
                    <MenuItem
                      sx={memberHeaderStyles.menuListItem(theme)}
                      disableGutters
                      onClick={() => handleNumberOfDaysClick(1)}
                      selected={false}
                    >
                      {'Yesterday'}
                    </MenuItem>
                    <MenuItem
                      sx={memberHeaderStyles.menuListItem(theme)}
                      disableGutters
                      onClick={() => handleNumberOfDaysClick(7)}
                      selected={false}
                    >
                      {'Last Week'}
                    </MenuItem>
                    <MenuItem
                      sx={memberHeaderStyles.menuListItem(theme)}
                      disableGutters
                      onClick={() => handleNumberOfDaysClick(30)}
                      selected={false}
                    >
                      {'Last Month'}
                    </MenuItem>
                    <MenuItem
                      sx={memberHeaderStyles.menuListItem(theme)}
                      disableGutters
                      onClick={() => handleNumberOfDaysClick(90)}
                      selected={false}
                    >
                      {'Last Quarter'}
                    </MenuItem>
                    <MenuItem
                      sx={memberHeaderStyles.menuListItem(theme)}
                      disableGutters
                      onClick={() => handleNumberOfDaysClick(365)}
                      selected={false}
                    >
                      {'Last Year'}
                    </MenuItem>
                  </Menu>
              </Box>
              {
                isDemoMode
                ? <Box
                    sx={memberHeaderStyles.toggleContainer(theme)}
                  >
                  <Tooltip
                    aria-label={'Help'}
                    title={'Help'}
                  >
                    <Button
                      sx={memberHeaderStyles.navButton(theme)}
                    >
                      <i className='icon-help' />
                      <div>{'Help'}</div>
                    </Button>
                  </Tooltip>
                </Box>
                : null
              }
            </Grid>
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default AnalyticsHeader;
